// Global Instructions Rule Applied!
// Record-link targets for the relationships surfaces. The app's tab shell
// parses these routes (tabSlice parseRoute) and opens the record in a tab.
export const accountFormPath = (accountId: string): string => `/companies/forms/full/${accountId}`
export const prospectFormPath = (prospectId: string): string => `/fundraising/forms/full/${prospectId}`
